// extracted by mini-css-extract-plugin
module.exports = {"Flex":"ReportProblemLink_Flex__V8fii","Icon":"ReportProblemLink_Icon__pIBQe","Link":"ReportProblemLink_Link__bLlHb"};